module.exports = __webpack_public_path__ + "static/background_1024-ec90d5752dfda99258271899d16dce3d.png";